import { createTheme } from '@mui/material/styles'
import { esES } from '@mui/material/locale'

import tokens from './base'
import cssBaseline from './base/cssBaseline'

import { mergeDeep } from './utils'
import elements from './elements'
import { utils } from './constants'

const theme = createTheme(esES, {
  ...tokens,
  components: { ...mergeDeep(elements), ...cssBaseline },
  utils,
})

export default theme
